import React, { useEffect, useState } from 'react';
import '../../CSS/cardStyles.css';
import { getTranslations } from '../../utils/CardTranslations';

const CardOpeningWrapper = ({ data, openingStyle = 'Tingkap A', children, openingColor = '#f2f2f', onOpen }) => {
  const t = getTranslations(data?.language);
  const [isOpen, setIsOpen] = useState(false);

  // Reset open state whenever openingStyle changes
  useEffect(() => {
    setIsOpen(false);
  }, [openingStyle]);

  const getStyleClass = () => {
    if (openingStyle === 'Tingkap B') return 'tingkap-b';
    if (openingStyle === 'Tingkap C') return 'tingkap-c';
    if (openingStyle === 'Tingkap D') return 'tingkap-d';
    return 'tingkap-a';
  };

  const handleOpen = () => {
    setIsOpen(true);
    if (onOpen) onOpen(); // notify parent that card is opened
  };


  return (
    <div className={`card-wrapper ${getStyleClass()} ${isOpen ? 'open' : ''}`} style={{ width: "300px" }}>
      {/* Flaps */}
      {openingStyle === 'Tingkap B' ? (
        <>
          <div className="flap top-flap" style={{ backgroundColor: openingColor }} />
          <div className="flap bottom-flap" style={{ backgroundColor: openingColor }} />
        </>
      ) : openingStyle === 'Tingkap C' ? (
        <>
          <div className="curtain-half curtain-left" style={{ backgroundColor: openingColor }} />
          <div className="curtain-half curtain-right" style={{ backgroundColor: openingColor }} />
        </>
      ) : openingStyle === 'Tingkap D' ? (
        <>
          <div className="envelope-flap envelope-pocket" />
          <div className="envelope-top-wrapper">
            <div className="envelope-flap envelope-top" style={{ backgroundColor: openingColor }} />
          </div>
        </>
      ) : (
        <>
          <div className="flap left-flap" style={{ backgroundColor: openingColor }} />
          <div className="flap right-flap" style={{ backgroundColor: openingColor }} />
        </>
      )}

      {/* Buka Button */}
      {openingStyle === 'Tingkap D' ? (
        <div
          className={`envelope-seal ${isOpen ? 'open' : ''}`}
          style={{ '--button-scale': 0.7 }}
          onClick={handleOpen}
          role="button"
          tabIndex={0}
          onKeyDown={(event) => event.key === 'Enter' && handleOpen()}
          aria-label={t.openCardButton}
        >
          <img src="/card-backgrounds/wax-seal.png" alt="" />
          <div className="envelope-seal-text">
            <span
              className="envelope-seal-names"
              style={{
                fontFamily: data?.fontNamingOpenCardStyle,
                fontSize: data?.openCardName
                  ? (data.openCardName.length > 20 ? "9px" : data.openCardName.length > 13 ? "10px" : "12px")
                  : (data?.coupleCount === 'dua' ? "9px" : "11px"),
              }}
            >
              {data?.openCardName ? (
                data.openCardName.split(' & ').map((name, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <br />}
                    {name}
                  </React.Fragment>
                ))
              ) : data?.coupleCount === 'dua' ? (
                <>
                  {data?.greetingName?.replace(/ & /g, '/')}
                  <br />
                  <span style={{ fontSize: "0.85em", opacity: 0.8, display: "inline-block", padding: "1px 0" }}>&amp;</span>
                  <br />
                  {data?.greetingName2?.replace(/ & /g, '/')}
                </>
              ) : (
                (data?.greetingName || 'Adam & Hawa').split(' & ').map((name, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <br />}
                    {name}
                  </React.Fragment>
                ))
              )}
            </span>
            <span className="envelope-seal-buka">{t.openCardButton}</span>
          </div>
        </div>
      ) : (
        !isOpen && (
          <div
            className="buka-button"
            style={{
              '--button-scale': 0.7,
              backgroundColor: data?.themeColour || '#68D2D2',
              '--theme-colour': data?.themeColour || '#68D2D2'
            }}
            onClick={handleOpen}
          >
            <span style={{
              fontSize: data?.openCardName
                ? (data.openCardName.length > 22 ? "0.8rem" : data.openCardName.length > 14 ? "0.9rem" : "1.1rem")
                : (data?.coupleCount === 'dua' ? "0.8rem" : "1rem")
            }}>
              {data?.openCardName ? (
                data.openCardName.split(' & ').map((name, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <br />}
                    {name}
                  </React.Fragment>
                ))
              ) : data?.coupleCount === 'dua' ? (
                <>
                  {data.greetingName?.replace(/ & /g, '/')}
                  <br />
                  <span style={{ fontSize: "0.85em", opacity: 0.8, display: "inline-block", padding: "2px 0" }}>&amp;</span>
                  <br />
                  {data.greetingName2?.replace(/ & /g, '/')}
                </>
              ) : (
                (data?.greetingName || 'Adam & Hawa').split(' & ').map((name, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && <br />}
                    {name}
                  </React.Fragment>
                ))
              )}
            </span>
            <div>{t.openCardButton}</div>
          </div>
        )
      )}

      {/* Card Content */}
      <div className="card-content">
        {children}
      </div>
    </div>
  );
};

export default CardOpeningWrapper;
